/**
 * Amenities Block.
 * 
 */

let 
	$window = $(window),
	prevWindowW = $window.width(),
	currWindowW = prevWindowW,
	sliderBreakpoint = 768,

	$mySlider = $('.amenities-chips'),
	optionsMobile = {
		adaptiveHeight:true,
		arrows:true,
		appendArrows:$('.amenities-block__arrow-nav'),
		centerMode:false,
		cssEase:'ease-out',
		dots:false,
		// appendDots:$('.amenities-block__dot-nav'),
		fade:true,
		infinite:true,
		mobileFirst:true,
		slidesToShow:1,
		// slidesToScroll:2,
		swipe:true,
		swipeToSlide:true,
	},
	optionsDesktop = {
		adaptiveHeight:true,
		arrows:true,
		appendArrows:$('.amenities-block__arrow-nav'),
		centerMode:false,
		cssEase:'ease-out',
		dots:false,
		// appendDots:$('.amenities-block__dot-nav'),
		// fade:true,
		infinite:true,
		mobileFirst:true,
		slidesToShow:3,
		// slidesToScroll:2,
		swipe:true,
		swipeToSlide:true,
		responsive: [
			{
				breakpoint:510,
				// breakpoint:480,
				settings: {
					slidesToShow:2,
					// slidesToScroll:2,
				}
			},
			{
				breakpoint:768,
				// breakpoint:800,
				settings: {
					slidesToShow:3,
					// slidesToScroll:3,
				}
			},
			{
				breakpoint:1024,
				// breakpoint:800,
				settings: {
					// arrows:false,
					slidesToShow:4,
					// slidesToScroll:4,
				}
			// },
			// {
			//     breakpoint:1200,
			//     // breakpoint:800,
			//     settings: {
			//         arrows:false,
			//         slidesToShow:5,
			//     }
			}
		]
	},
	unslickedHtml;


function initAmenitiesSlider() {
	// Mobile: single slide, dot nav.
	// Desktop: 2 to 4 across slides, arrow nav.
	console.log('AMENITIES: initAmenitiesSlider()');

    let 
		wwidth = $(window).width();

	unslickedHtml = $mySlider[0].outerHTML;

	if (wwidth < sliderBreakpoint) {
		console.log('AMENITIES: MOBILE');
		$mySlider.slick(optionsMobile);
	} else {
		console.log('AMENITIES: DESKTOP');
		$mySlider.slick(optionsDesktop);
	}
}

function initResizeWatcher() {
	// console.log('AMENITIES: initResizeWatcher()');
	$window.on('resize', function() {
		currWindowW = $window.width();
		console.log('AMENITIES: WINDOW RESIZED: '+currWindowW+': '+prevWindowW);
		// Viewport width crosses from mobile to desktop.
		if ((currWindowW >= sliderBreakpoint) && (prevWindowW < sliderBreakpoint)) {
			console.log('AMENITIES: WINDOW RESIZED: kill mobile / init desktop');
			// Kill mobile slider, init desktop slider.
			$mySlider.slick('unslick');
			initAmenitiesSlider();
		}
		// Viewport width crosses from desktop to mobile.
		if ((currWindowW < sliderBreakpoint) && (prevWindowW >= sliderBreakpoint)) {
			console.log('AMENITIES: WINDOW RESIZED: kill desktop / init mobile');
			// Kill desktop slider, init mobile slider.
			// For some reason, the chip markup disappears but chips and some slick markup remains. So...
			// 0. Save pre-slicked .amenities-chips and children HTML in unslickedHtml.
			// 1. Unslick slider.
			// 2. Remove .amenities-chips and leftover children HTML.
			// 3. Prepend unslickedHtml to .amenities-chips parent.
			// 4. Redefine/point $mySlider to newly restored .amenities-chips.
			// 5. Init slider!
			$mySlider.slick('unslick');
			$mySlider.remove();
			$('.amenities-block .container-1412').prepend(unslickedHtml);
			$mySlider = $('.amenities-chips');
			initAmenitiesSlider();
		}
		prevWindowW = $window.width();
	});
}

 exports.init = function () {
	// console.log('AMENITIES: exports.init');
	// Run init methods...

	initAmenitiesSlider();
	initResizeWatcher();
};